"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabBody = exports.TabHeader = exports.Tab = exports.TabLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
require("./TabLayout.css");
var TabLayoutContext_1 = require("./TabLayoutContext");
var TabLayout = function (_a) {
  var _b = _a.floatingHeader,
    floatingHeader = _b === void 0 ? false : _b,
    _c = _a.headerHeight,
    headerHeight = _c === void 0 ? 0 : _c,
    _d = _a.headerWidth,
    headerWidth = _d === void 0 ? 0 : _d,
    _e = _a.lazy,
    lazy = _e === void 0 ? false : _e,
    selectedId = _a.selectedId,
    children = _a.children,
    themeColor = _a.themeColor,
    onTabClick = _a.onTabClick,
    selectTab = _a.selectTab,
    restProps = __rest(_a, ["floatingHeader", "headerHeight", "headerWidth", "lazy", "selectedId", "children", "themeColor", "onTabClick", "selectTab"]);
  var _f = __read((0, react_1.useState)({}), 2),
    labels = _f[0],
    setLabels = _f[1];
  var setLabel = function (id, label) {
    setLabels(function (_labels) {
      var _a;
      return __assign(__assign({}, _labels), (_a = {}, _a[id] = label, _a));
    });
  };
  var removeLabel = function (id) {
    setLabels(function (_labels) {
      return R.dissoc(id, _labels);
    });
  };
  var labelMap = (0, react_1.useMemo)(function () {
    return Object.entries(labels).map(function (_a, index) {
      var _b = __read(_a, 2),
        id = _b[0],
        _c = _b[1],
        content = _c.content,
        disabled = _c.disabled;
      return (0, jsx_runtime_1.jsx)(TabLabel, __assign({
        tabId: id,
        themeColor: themeColor,
        onTabClick: onTabClick,
        onSelectClick: selectTab,
        disabled: disabled
      }, {
        children: content
      }), index);
    });
  }, [labels]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    children: (0, jsx_runtime_1.jsxs)(TabLayoutContext_1.TabLayoutContext.Provider, __assign({
      value: {
        lazy: lazy,
        setLabel: setLabel,
        removeLabel: removeLabel,
        selectedId: selectedId
      }
    }, {
      children: [(0, jsx_runtime_1.jsx)(exports.TabHeader, __assign({
        floatingHeader: floatingHeader,
        headerWidth: headerWidth
      }, {
        children: labelMap
      })), (0, jsx_runtime_1.jsx)(exports.TabBody, __assign({
        floatingHeader: floatingHeader,
        headerHeight: headerHeight
      }, {
        children: children
      }))]
    }))
  }));
};
exports.TabLayout = TabLayout;
var Tab = function (_a) {
  var label = _a.label,
    id = _a.id,
    children = _a.children,
    className = _a.className,
    disabled = _a.disabled;
  var _b = (0, react_1.useContext)(TabLayoutContext_1.TabLayoutContext),
    setLabel = _b.setLabel,
    removeLabel = _b.removeLabel,
    selectedId = _b.selectedId,
    lazy = _b.lazy;
  var selected = !R.isEmpty(selectedId) && id == selectedId;
  var rendered = !lazy || lazy && selected;
  (0, react_1.useEffect)(function () {
    setLabel(id, {
      content: label,
      disabled: disabled
    });
    return function () {
      return removeLabel(id);
    };
  }, [label, disabled]);
  return rendered ? (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)("vsx-tab-content standard", className),
    hidden: !selected
  }, {
    children: children
  })) : null;
};
exports.Tab = Tab;
var TabLabel = function (_a) {
  var _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    tabId = _a.tabId,
    children = _a.children,
    _c = _a.onTabClick,
    onTabClick = _c === void 0 ? R.N : _c,
    onSelectClick = _a.onSelectClick,
    themeColor = _a.themeColor,
    restProps = __rest(_a, ["disabled", "tabId", "children", "onTabClick", "onSelectClick", "themeColor"]);
  var selectedId = (0, react_1.useContext)(TabLayoutContext_1.TabLayoutContext).selectedId;
  var _d = __read((0, react_1.useState)(false), 2),
    hover = _d[0],
    setHover = _d[1];
  var selected = !R.isNothing(selectedId) && tabId == selectedId;
  var labelStateClassName = (0, react_1.useMemo)(R.cond([[R.always(disabled), R.always("vsx-tab-label-disabled")], [R.always(selected), R.always("vsx-tab-label-clicked")], [R.T, function () {
    return null;
  }]]), [disabled, selected]);
  var labelClassName = (0, classnames_1.default)("vsx-tab-label", labelStateClassName);
  var accentColor = themeColor !== null && themeColor !== void 0 ? themeColor : "#49c5b1";
  var hoverStyle = (0, react_1.useMemo)(R.cond([[R.always(disabled || selected), function () {
    return {};
  }], [R.always(hover), function () {
    return {
      color: accentColor,
      cursor: "pointer"
    };
  }], [R.T, function () {
    return {
      color: "#888"
    };
  }]]), [disabled, selected, hover]);
  var labelStyle = selected ? {
    borderBottom: "4px solid ".concat(accentColor)
  } : {};
  var onMouseOver = function () {
    setHover(true);
  };
  var onMouseLeave = function () {
    setHover(false);
  };
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: labelClassName,
    onClick: function (event) {
      if (!disabled) {
        onSelectClick(event, tabId);
        onTabClick();
      }
    },
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    style: hoverStyle
  }, {
    children: (0, jsx_runtime_1.jsx)("div", __assign({
      role: "tab",
      style: labelStyle
    }, {
      children: (0, jsx_runtime_1.jsx)(TabLabelContent, {
        children: children
      })
    }))
  }));
};
var TabLabelContent = function (_a) {
  var children = _a.children,
    restProps = __rest(_a, ["children"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: "vsx-tab-label-content standard"
  }, {
    children: children
  }));
};
var TabHeader = function (_a) {
  var children = _a.children,
    floatingHeader = _a.floatingHeader,
    headerWidth = _a.headerWidth,
    restProps = __rest(_a, ["children", "floatingHeader", "headerWidth"]);
  var cn = (0, classnames_1.default)("vsx-tab-header", floatingHeader && "vsx-tab-header-floating");
  var headerCss = floatingHeader ? {
    width: "".concat(headerWidth)
  } : {};
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: cn,
    role: "tablist",
    style: headerCss
  }, {
    children: children
  }));
};
exports.TabHeader = TabHeader;
var TabBody = function (_a) {
  var children = _a.children,
    floatingHeader = _a.floatingHeader,
    headerHeight = _a.headerHeight,
    restProps = __rest(_a, ["children", "floatingHeader", "headerHeight"]);
  var headerHeightCss = floatingHeader ? {
    paddingTop: "".concat(headerHeight)
  } : {};
  return (0, jsx_runtime_1.jsx)("div", __assign({}, restProps, {
    className: "vsx-tab-body",
    role: "tabpanel",
    style: headerHeightCss
  }, {
    children: children
  }));
};
exports.TabBody = TabBody;